export default "__VITE_ASSET__BMY2irbT__"